/**
 * @module quoteStatus
 * @description A list of quoteStatus
 */

export const quoteStatus = ['draft', 'sent', 'ordered'] as const;
export type QuoteStatus = (typeof quoteStatus)[number];
